import React from 'react';
import {useSalesforceDealRecordTypeQuery, SalesforceDealField} from 'api';
import useSearchParams from '../../../../../useSearchParams';
import {Listbox} from '@headlessui/react';
import ArrowDownIcon from './ArrowDownIcon';

type CustomizeItemFilterItem = {
  salesforceDealFieldId: string;
  index: number;
};

export default ({salesforceDealFieldId, index}: CustomizeItemFilterItem) => {
  const {query, setQuery} = useSearchParams();
  const {
    data: {salesforceDealRecordType: {salesforceDealFields = []} = {}} = {},
  } = useSalesforceDealRecordTypeQuery({
    variables: {
      salesforceDealRecordTypeId: query.salesforceDealRecordTypeId,
    },
    skip: !query.salesforceDealRecordTypeId,
  });

  const selectedFields = () => {
    return query.salesforceDealSearchConditions.map(
      (condition) => condition['salesforce_deal_field_id'],
    );
  };

  const selectedItem = (id: string): SalesforceDealField => {
    return salesforceDealFields.find(
      (salesforceDealField) => salesforceDealField.id === id,
    );
  };

  const customizeItems = React.useMemo(() => {
    return salesforceDealFields.filter(
      (item) =>
        (item.fieldType === 'select' || item.fieldType === 'multi_select') &&
        item.fieldName.endsWith('__c') &&
        !selectedFields().includes(item.id),
    );
  }, [salesforceDealFields]);

  return (
    <div className="relative">
      <Listbox
        value={salesforceDealFieldId ?? ''}
        onChange={(value) => {
          setQuery({
            ...query,
            salesforceDealSearchConditions: [
              ...query.salesforceDealSearchConditions.slice(0, index),
              {
                salesforce_deal_field_id: value,
                field_type: selectedItem(value)?.fieldType,
              },
              ...query.salesforceDealSearchConditions.slice(index + 1),
            ],
          });
        }}>
        <Listbox.Button className="relative px-3 text-left focus:outline-none flex items-center border rounded w-80 h-8 bg-white border-[#d9d9d9] justify-between truncate">
          <span>{selectedItem(salesforceDealFieldId)?.label}</span>
          <ArrowDownIcon />
        </Listbox.Button>
        <Listbox.Options className="absolute">
          {customizeItems.map((salesforceDealField) => (
            <Listbox.Option
              className={({active}) =>
                `relative select-none py-2 px-3 cursor-pointer w-80 h-8 pr-10 truncate z-20 ${
                  active ? 'bg-gray-100' : 'bg-white'
                }`
              }
              key={salesforceDealField.id}
              value={salesforceDealField.id}>
              {salesforceDealField.label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
};
